import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useCareUserContext } from './provider/careUserContext';
import ColumnDragTR from './ColumnDragTR';
import AddEditCareColumn from './AddEditCareColumn';
import { manualStatusColours } from '../../../Components/helper';
import DragDropSort from '../../../Components/DragDropSort/DragDropSort';
import { updateSequenceUserInstructionAction, fetchColumnDetailList } from './store/UserInstruction.action';
import ConfirmationPopup from '../../../Components/ModalPopup/ConfirmationPopup';
import * as action from './store/UserInstruction.action';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';

export default function ColumnTableModal({ tabName }) {
  const { state, setState } = useCareUserContext();
  const params = useParams();
  const dispatch = useDispatch();
  const [showDragDrop, setShowDragDrop] = useState(false);
  const { t } = useTranslation('common');

  const handleClose = () => {
    setState((prevState) => ({
      ...prevState,
      showColumnConfig: false,
      editMode: false,
      addColumns: [],
    }));
  };

  const handleColumn = () => {
    setState((prevState) => ({
      ...prevState,
      showAddEditColumn: true,
      editMode: false,
      addColumns: [
        {
          name: '',
          columnType: null,
          isRequired: false,
          options: [{ name: '' }],
          status: null,
          statusColoursOptions: manualStatusColours,
          isStatusEditTrue: false,
          characterLimit: '',
          colorSwitch: false,
          colourArray: [
            {
              colourValue: '',
              colourType: 'green',
              startPercentage: '',
              endPercentage: '',
            },
            {
              colourValue: '',
              colourType: 'amber',
              startPercentage: '',
              endPercentage: '',
            },
            {
              colourValue: '',
              colourType: 'red',
              startPercentage: '',
              endPercentage: '',
            },
          ],
        },
      ],
    }));
  };

  const hideShowDragDrop = () => {
    setShowDragDrop(!showDragDrop);
  };

  const handleSaveSequence = async (_e, sequenceList) => {
    const data = {
      id: params?._id,
      columns: sequenceList?.sequence,
    };
    await dispatch(updateSequenceUserInstructionAction(data, t));
    await dispatch(fetchColumnDetailList(params?._id));
    hideShowDragDrop();
  };

  const handleConfirmDelete = async () => {
    const res = await dispatch(action.deleteColumns(state?.deleteColumnId, t));
    if (res) {
      const newColumns = state?.columns?.filter((ele) => ele?._id !== state?.deleteColumnId);
      setState((prevState) => ({
        ...prevState,
        deleteColumnId: '',
        selectedIds: [],
        columns: newColumns,
      }));
    }

    setState((prevState) => ({
      ...prevState,
      showConfirmationPopup: false,
    }));
  };

  const toggleConfirmPopup = () => {
    setState((prevState) => ({
      ...prevState,
      showConfirmationPopup: false,
      deleteColumnId: '',
    }));
  };

  const mainRender = () => {
    return state?.showAddEditColumn ? (
      <AddEditCareColumn />
    ) : (
      <Modal className="common-custom-modal modal-large" backdrop="static" show={state?.showColumnConfig} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>
            {t('COMMON_LABEL.EDIT')} {tabName}
          </Modal.Title>
          <div className="d-flex align-items-center ml-auto">
            <p className="m-0 mr-2">{state?.columns?.length >= 10 && t('subMenu.MAXIMUM_COLUMNS_ADDDED')}</p>
            <CustomTooltip tooltipText={t('COMMON_LABEL.REARRANGE')}>
              <button aria-label="rearrange" className="btn d-inline-flex p-0 mr-16 " onClick={hideShowDragDrop} type="button">
                <i className="icon-Rearrange text-grey f-24" />
              </button>
            </CustomTooltip>
            <CustomTooltip tooltipText={t('COMMON_LABEL.ADD_COLUMN')}>
              <button aria-label="add" type="submit" disabled={state?.columns?.length >= 10} onClick={handleColumn} className="btn d-inline-flex p-0 mr-16">
                <i className="icon-Add f-24 text-grey" />
              </button>
            </CustomTooltip>
            <CustomTooltip tooltipText={t('COMMON_LABEL.CLOSE')}>
              <span onClick={handleClose} aria-label="close" className="icon-close cursor-pointer" />
            </CustomTooltip>
          </div>
        </Modal.Header>
        <Modal.Body>
          <table className="table common-custom-table layout-fixed">
            <thead>
              <tr>
                <th aria-label="checkbox" className="w-50px">
                  &nbsp;
                </th>
                <th className="w-300px">{t('CUSTOM_MODULE.FIELD_NAME')}</th>
                <th className="w-200px">{t('CUSTOM_MODULE.TYPE')}</th>
                <th aria-label="action" className="w-100px" />
              </tr>
            </thead>
            <tbody>
              {state?.columns?.map((colEle, colIndex) => (
                <ColumnDragTR key={colEle._id} colEle={colEle} colIndex={colIndex} />
              ))}
            </tbody>
          </table>
          {showDragDrop && (
            <DragDropSort
              itemList={state?.columns}
              isShow={showDragDrop}
              isToggle={hideShowDragDrop}
              saveSequence={handleSaveSequence}
              fromComp="careUserInstructions"
            />
          )}
        </Modal.Body>
      </Modal>
    );
  };

  return state?.showConfirmationPopup ? (
    <ConfirmationPopup
      onOpen={state?.showConfirmationPopup}
      toggle={toggleConfirmPopup}
      onConfirm={handleConfirmDelete}
      title={t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION.DELETE_MESSAGE')}
      message={t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION.CONFIRMATION_MESSAGE')}
    />
  ) : (
    mainRender()
  );
}
